/**
 * Search for a spezified field in a certificate field map.
 * @param fieldMapping field_mapping value of the certificate
 * @param informationType information type which looking for
 * @returns value of the found field or undefined when field not found
 */
export const findRecipientInformation = (fieldMapping: Fieldmapping[], informationType: string) =>
    fieldMapping.find((f) => f.id === informationType)?.value;
